import { Component } from '@angular/core';

@Component({
  selector: 'orgbrain-page-not-found-dialog',
  templateUrl: './page-not-found-dialog.component.html',
  styleUrls: ['./page-not-found-dialog.component.scss'],
    standalone: false
})
export class PageNotFoundDialogComponent {}
